
import { Options } from "vue-class-component";
import ComponentMixins from "../ComponentMixins";
import UserPickerComponent from "../../../components/UserPicker/UserPicker.vue";

@Options({
    name: "flowable-common-form-components-user-picker",
    components: { UserPicker: UserPickerComponent },
    props: {
        placeholder: {
            type: String,
            default: "请选择人员",
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        readerMode: {
            type: Boolean,
            default: false,
        },
    },
})
export default class PostPicker extends ComponentMixins {
    public selected(values: any) {
        this._value = values;
    }
    public delUser(i: any) {
        this._value.splice(i, 1);
    }
}
